const popupModal = () => {
  const popup = document.getElementById('popupMessage');
  if (!popup) {
    return;
  }
  const btnDismissPopup = document.querySelectorAll('.btn--popup-dismiss');
  const uniquePopupID = popup.dataset.identifier;
  window.theme.popupIsOpen = false;

  function setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
      value,
      expiry: now.getTime() + ttl,
    };
    window.localStorage.setItem(key, JSON.stringify(item));
  }

  function getWithExpiry(key) {
    const itemStr = window.localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      window.localStorage.removeItem(key);
      return false;
    }
    return true;
  }

  function showPopup() {
    window.theme.popupIsOpen = true;
    popup.classList.add('is-shown');
    popup.classList.remove('is-hidden');
  }

  function dismissPopup() {
    window.theme.popupIsOpen = false;
    popup.classList.remove('is-shown');
    popup.classList.add('is-hidden');
    setWithExpiry('popupMessage', uniquePopupID, 86400000); // Set expiry to 24hrs
  }

  if (popup) {
    getWithExpiry('popupMessage'); // Check for the stored value, clear if expired.
    if (
      window.localStorage.getItem('popupMessage') &&
      JSON.parse(window.localStorage.getItem('popupMessage')).value === uniquePopupID
    ) {
      return;
    } else {
      // The message can be shown
      showPopup();
    }

    // Close mmodal with button
    btnDismissPopup.forEach(button => {
      button.addEventListener('click', dismissPopup);
    });

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target === popup) {
        dismissPopup();
      }
    };
  }
};

export default popupModal;
